// Copyright (c) 2015, Sony Global Education, Inc.
// All rights reserved.

////////////////////////////////////////////////////////////
//
// Constants

export const MMVERSION = "1.0.4";
export const MMFORMATVERSION = "3";

// Below paths should be relative.

// MathMind base.
export const MMIND_BASE = "/mmind";

// Path part for mmind.
export const MMIND_PATH = MMIND_BASE + "/";

// Path part for quiz.
export const QUIZ_PATH = MMIND_BASE + "/quiz";

// Path part for result.
export const RESULT_PATH = MMIND_BASE + "/result";

// Path part for five thinking.
export const ABOUT_PATH = MMIND_BASE + "/fthinking";

// Path part for About Site.
export const ASITE_PATH = MMIND_BASE + "/asite";

// Path part for Answers Site.
export const ANSWERS_PATH = MMIND_BASE + "/answers";

// Path part for WhatIsGMC Site.
export const WHAT_IS_GMC_PATH = MMIND_BASE + "/agmc";

// Below paths should be absolute.

// GMC Base path.
export const GMC_BASE_PATH = "https://mmind.sonyged.com";
export const GMC_BASE_PATH_JA = "https://mmind.sonyged.com/ja/";
export const GMC_BASE_PATH_ZH = "https://mmind.sonyged.com/zh/";

// URL for GMC top page.
export const GMC_TOPPAGE_URL = {
  en: GMC_BASE_PATH,
  ja: GMC_BASE_PATH_JA,
  zh: GMC_BASE_PATH_ZH,
};

// URL for MMind top page.
export const PR_TOPPAGE_URL = {
  en: GMC_BASE_PATH,
  ja: GMC_BASE_PATH_JA,
  zh: GMC_BASE_PATH_ZH,
};

// URL for Global Math Challenge top.
export const GLOBAL_MATH_CHALLENGE_TOP_URL = GMC_BASE_PATH + "/";

// URL for Global Math Challenge top.
export const GLOBAL_MATH_CHALLENGE_SIGNUP_URL = GMC_BASE_PATH + "/";

// URL for Mini Math Challenge page.
export const MINI_MATH_CHALLENGE_PAGE_URL = GMC_BASE_PATH + "/pr";

// URL for 17Z special site.
export const SPECIAL_17Z_PAGE_URL =
  "http://www.17zuoye.com/student/challenge/index.vpage";
// URL for 17Z wechat site.
export const SPECIAL_17Z_WECHAT_PAGE_URL =
  "http://wx.17zuoye.com/funchallenge/index";

// Question index.
export const LAST_QUESTION_INDEX = 5;
export const CALC_INDEX = 6;

// Wrong answer time.  It might be logic error.
export const INVALID_ANSWER_TIME = 999999;

// Wait before chaing section for recognizing tapped answer for user.
export const NEXT_QUESTION_MOVE_WAIT = 100;

// Reduce animation second from answer time.
export const SECTION_START_MARGIN_TIME = 600;

// Calcurating animation before flip
export const CALCULATING_TIME = 2800;

// Wait for flip stop.
export const FLIP_WAIT_TIME = 300;

export const TRANSLATION_BASE = "js.";
export const T = TRANSLATION_BASE; // XXX

// Twitter
export const TWITTER_DEFAULT_TEXT = T + "twitter.default_description";

// Facebook
export const FACEBOOK_NAME = T + "facebook.title";
export const FACEBOOK_CAPTION = "mmind.sonyged.com";
export const FACEBOOK_DEFAULT_DESCRIPTION = T + "facebook.default_description";
export const FACEBOOK_DEFAULT_PICTURES = {
  en: GMC_BASE_PATH + "/sns_images/fb-pos_top.png",
  ja: GMC_BASE_PATH + "/sns_images/fb-pos_top.png",
  zh: GMC_BASE_PATH + "/sns_images/fb-pos_top.png",
};

// Weibo
export const WEIBO_TITLE = T + "weibo.title";
export const WEIBO_DEFAULT_DESCRIPTION = T + "weibo.default_description";

// WeChat
export const WECHAT_CSS_CLASS = "icon_wc_flat";
export const WECHAT_A_TEXT = "Post to WeChat";

// Divide answering time to 3 stage.
export const ANSWER_SECONDS = [25000, 55000, -1];

// points:= point * 4
// point := cat * 5
// cat := [< 25sec, < 55sec, over]

// Bedroom:
// From tim:
// Play the keyboard(a) -> Create
// (Play a video game -> None)
// Check the calendar(c) -> Reverse
// Fix the poster(d) -> Step, Scan
//
// 調整: Play a video game -> 長時間: Knock 追加
export const QUESTION0 = [
  [
    [0, 0, 30, 0, 0],
    [0, 0, 30, 15, 0],
    [0, 0, 30, 30, 0],
  ],
  [
    [0, 0, 0, 0, 0],
    [0, 0, 0, 15, 0],
    [0, 0, 0, 60, 0],
  ],
  [
    [0, 30, 0, 0, 0],
    [0, 30, 0, 15, 0],
    [0, 30, 0, 30, 0],
  ],
  [
    [30, 0, 0, 0, 30],
    [30, 0, 0, 15, 30],
    [30, 0, 0, 30, 30],
  ],
];

// Shibuya
// From tim:
// - 1人: 全時間: Reverse/Create/Knock: 小
// - 2人: 全時間: Reverse/Create/Knock: 小
// - 3人: 短時間: Scan: 大、中時間: Step/Scan: 中、長時間: Step: 大
// - 4人: 全時間: Reverse/Create/Knock: 小
export const QUESTION1 = [
  [
    [0, 10, 10, 10, 0],
    [0, 10, 10, 10, 0],
    [0, 10, 10, 15, 0],
  ],
  [
    [0, 10, 10, 10, 0],
    [0, 10, 10, 10, 0],
    [0, 10, 10, 15, 0],
  ],
  [
    [0, 0, 0, 0, 30],
    [15, 0, 0, 0, 15],
    [30, 0, 0, 5, 0],
  ],
  [
    [0, 10, 10, 10, 0],
    [0, 10, 10, 10, 0],
    [0, 10, 10, 15, 0],
  ],
];

// What’s the Date Today?
// From ikenaga:
// [正解]: 1月1日
// GMC1: Calendar
// ■今日は何日
// 選択肢 1月1日 2月29日 9月27日 12月31日
// 1月1日 => Reverse 大 / Scan 中
// (2月29日 -> なし)
// (9月27日 -> なし)
// 12月31日 => Reverse 中 / Scanマイナス[マイナスが可能なら]
// その他 => 特になし
export const QUESTION2 = [
  [
    [0, 30, 0, 0, 20],
    [0, 30, 0, 5, 20],
    [0, 30, 0, 10, 20],
  ],
  [
    [0, 0, 0, 0, 0],
    [0, 0, 0, 5, 0],
    [0, 0, 0, 10, 0],
  ],
  [
    [0, 0, 0, 0, 0],
    [0, 0, 0, 5, 0],
    [0, 0, 0, 10, 0],
  ],
  [
    [0, 20, 0, 0, -10],
    [0, 20, 0, 5, -10],
    [0, 30, 0, 10, -10],
  ],
];

// Tennis Tournament
// From ikenaga:
// [正解]: 99
//----
// A 諦める -> (scan)
// B 99試合分の予約をする -> (create > scan)
// C 101試合分の予約をする -> (none)
// D 199試合分の予約をする -> (none)
//
// Aを選んだら、捨てる力として、scan
// Bを選んだら、create (ただし、一定時間以上かかった場合はScan)
// その他は、特になし
export const QUESTION3 = [
  [
    [0, 0, 0, 0, 30],
    [0, 0, 0, 5, 30],
    [0, 0, 0, 10, 30],
  ],
  [
    [0, 0, 30, 0, 0],
    [0, 0, 10, 5, 10],
    [0, 0, 0, 10, 30],
  ],
  [
    [0, 0, 0, 0, 0],
    [0, 0, 0, 5, 0],
    [0, 0, 0, 10, 0],
  ],
  [
    [0, 0, 0, 0, 0],
    [0, 0, 0, 5, 0],
    [0, 0, 0, 10, 0],
  ],
];

// Ninja
// From tim:
//
// Earth Ninja -> Reverse/Knock
// Water Ninja -> Step
// Fire Ninja -> Create
// Wind Ninja -> Scan/Knock
//
// 調整: Earth Ninja -> 中長時間でReverse 減少
export const QUESTION4 = [
  [
    [0, 30, 0, 30, 0],
    [0, 15, 0, 45, 0],
    [0, 15, 0, 60, 0],
  ],
  [
    [30, 0, 0, 0, 0],
    [30, 0, 0, 15, 0],
    [30, 0, 0, 30, 0],
  ],
  [
    [0, 0, 30, 0, 0],
    [0, 0, 30, 15, 0],
    [0, 0, 30, 30, 0],
  ],
  [
    [0, 0, 0, 15, 30],
    [0, 0, 0, 30, 30],
    [0, 0, 0, 45, 30],
  ],
];
export const QUESTIONS = [
  QUESTION0,
  QUESTION1,
  QUESTION2,
  QUESTION3,
  QUESTION4,
];
export const CORRECT_ANSWERS = [-1, 2, 0, 1, -1];

// CAUTION: Should not try to generate "imgsrc_xx" value automatically in
// runtime.  "asset_path" is pre-processed by rails build system _BEFORE_
// javascript is invoked.
//
// Type0: Step
// Type1: Reverse
// Type2: Create
// Type3: Knock
// Type4: Scan

export const RESULTS = [
  // Type 0: Step
  {
    type_string: "step",
    type_short_string: "sp",
    title: T + "result.type0.title",
    simple_title: T + "result.type0.simple_title",
    subtitle: T + "result.type0.subtitle",
    detail: T + "result.type0.detail",
    imgsrc: "./src/images/common/img_step@2x.png",
    imgsrc_en: "./src/images/common/img_step@2x.png",
    imgsrc_ja: "./src/images/common/img_step@2x.png",
    imgsrc_zh: "./src/images/common/img_step@2x.png",
    imgalt: T + "result.type0.imgalt",
    twitter_text: T + "result.type0.twitter_text",
    fbimgsrc_en: "./src/images/common/facebook_type0.png",
    fbimgsrc_ja: "./src/images/common/facebook_type0.png",
    fbimgsrc_zh: "./src/images/common/facebook_type0.png",
    facebook_text: T + "result.type0.facebook_text",
  },

  // Type 1: Reverse
  {
    type_string: "reverse",
    type_short_string: "re",
    title: T + "result.type1.title",
    simple_title: T + "result.type1.simple_title",
    subtitle: T + "result.type1.subtitle",
    detail: T + "result.type1.detail",
    imgsrc: "./src/images/common/img_reverse@2x.png",
    imgsrc_en: "./src/images/common/img_reverse@2x.png",
    imgsrc_ja: "./src/images/common/img_reverse@2x.png",
    imgsrc_zh: "./src/images/common/img_reverse@2x.png",
    imgalt: T + "result.type1.imgalt",
    twitter_text: T + "result.type1.twitter_text",
    fbimgsrc_en: "./src/images/common/facebook_type1.png",
    fbimgsrc_ja: "./src/images/common/facebook_type1.png",
    fbimgsrc_zh: "./src/images/common/facebook_type1.png",
    facebook_text: T + "result.type1.facebook_text",
  },

  // Type 2: Create
  {
    type_string: "create",
    type_short_string: "ce",
    title: T + "result.type2.title",
    simple_title: T + "result.type2.simple_title",
    subtitle: T + "result.type2.subtitle",
    detail: T + "result.type2.detail",
    imgsrc: "./src/images/common/img_create@2x.png",
    imgsrc_en: "./src/images/common/img_create@2x.png",
    imgsrc_ja: "./src/images/common/img_create@2x.png",
    imgsrc_zh: "./src/images/common/img_create@2x.png",
    imgalt: T + "result.type2.imgalt",
    twitter_text: T + "result.type2.twitter_text",
    fbimgsrc_en: "./src/images/common/facebook_type2.png",
    fbimgsrc_ja: "./src/images/common/facebook_type2.png",
    fbimgsrc_zh: "./src/images/common/facebook_type2.png",
    facebook_text: T + "result.type2.facebook_text",
  },

  // Type 3: Knock
  {
    type_string: "knock",
    type_short_string: "kk",
    title: T + "result.type3.title",
    simple_title: T + "result.type3.simple_title",
    subtitle: T + "result.type3.subtitle",
    detail: T + "result.type3.detail",
    imgsrc: "./src/images/common/img_knock@2x.png",
    imgsrc_en: "./src/images/common/img_knock@2x.png",
    imgsrc_ja: "./src/images/common/img_knock@2x.png",
    imgsrc_zh: "./src/images/common/img_knock@2x.png",
    imgalt: T + "result.type3.imgalt",
    twitter_text: T + "result.type3.twitter_text",
    fbimgsrc_en: "./src/images/common/facebook_type3.png",
    fbimgsrc_ja: "./src/images/common/facebook_type3.png",
    fbimgsrc_zh: "./src/images/common/facebook_type3.png",
    facebook_text: T + "result.type3.facebook_text",
  },

  // Type 4: Scan
  {
    type_string: "scan",
    type_short_string: "sn",
    title: T + "result.type4.title",
    simple_title: T + "result.type4.simple_title",
    subtitle: T + "result.type4.subtitle",
    detail: T + "result.type4.detail",
    imgsrc: "./src/images/common/img_scan@2x.png",
    imgsrc_en: "./src/images/common/img_scan@2x.png",
    imgsrc_ja: "./src/images/common/img_scan@2x.png",
    imgsrc_zh: "./src/images/common/img_scan@2x.png",
    imgalt: T + "result.type4.imgalt",
    twitter_text: T + "result.type4.twitter_text",
    fbimgsrc_en: "./src/images/common/facebook_type4.png",
    fbimgsrc_ja: "./src/images/common/facebook_type4.png",
    fbimgsrc_zh: "./src/images/common/facebook_type4.png",
    facebook_text: T + "result.type4.facebook_text",
  },
];

// misc.

// move to check-anser site link chevron.
export const MOVE_TO_CHECK_ANSWER_SITE_CHEVRON_NORMAL =
  "./src/images/common/arrow-gray.png";
export const MOVE_TO_CHECK_ANSWER_SITE_CHEVRON_ON =
  "./src/images/common/arrow-grayon.png";

// move to mini math challenge site link icon.
export const MOVE_TO_MMCHALLENGE_SITE_ICON_NORMAL =
  "./src/images/common/blank-gray.png";
export const MOVE_TO_MMCHALLENGE_SITE_ICON_ON =
  "./src/images/common/blank-grayon.png";

// Google Analytics.
export const GA_SEND_CATEGORY = "mmind";
export const GA_SEND_ACTION = "click";
export const GA_SEND_LABEL_TWITTER = "twitter";
export const GA_SEND_LABEL_FACEBOOK = "facebook";
export const GA_SEND_LABEL_WEIBO = "weibo";
export const GA_SEND_LABEL_WECHAT = "wechat";
export const GA_SEND_LABEL_MOVETOAGMC = "mt_about_gmc";
export const GA_SEND_LABEL_MOVETOGMC = "mt_gmc";
export const GA_SEND_LABEL_MOVETOGMCSIGNUP = "mt_gmc_signup";

// design tweak
export const DYNAMIC_LINE_HEIGHT_CLASS_NAME = ".dynamic_line_height";
export const LINE_HEIGHT_NARROW_CLASS_NAME = "line_height_narrow";

// EOF
